<template>
  <div v-if="info" class="commmmission-tab-root" :class="[$i18n.locale === 'ar' ? 'ar-style' : '', packageName]">
    <div class="card-block">
      <!-- This Week Commission -->
      <div id="invite-target-dd" class="tit-tips right-read">
        <div class="block-title">
          {{ $t('lang.newInvite.k012') }}
          <img src="../images/rules-tips2.png" @click="toRules" />
        </div>
        <div class="beans-got">
          <img :src="getMatchImg('beans')" />
          {{ info.weekAgentCommissionBeans }}
        </div>
      </div>
      <div class="percent-bar" id="invite-target-cc">
        <PercentBar :percentCount="info.weekHostEarningBeans" :earnTypeList="info.commissionLevelList"></PercentBar>
      </div>
      <!-- vlolation-deduction -->
      <div class="vlolation-deduction right-read" @click="toViolationDetails">
        {{ $t('lang.newInvite.k013') }}
        <div>
          <img class="beans-icon" :src="getMatchImg('beans')" alt="" />
          <span>{{ info.weekHostDeductionBeans || 0 }}</span>
          <img class="arrow-icon ar-arrow" src="../images/arrow-r.png" alt="" />
        </div>
      </div>
    </div>

    <!-- Hostess Performance -->
    <div class="card-block pd-gap">
      <div class="block-title">{{ $t('lang.newInvite.k014') }}</div>
      <div class="deliver-line"></div>

      <div class="list-fields right-read">
        <div class="field field1">{{ $t('lang.wd.phAccount') }}</div>
        <div class="field field2">
          {{ $t('lang.dl.income') }}
          <img :src="getMatchImg('beans')" />
        </div>
        <div class="field field3">
          {{ $t('lang.dl.commission') }}
          <img :src="getMatchImg('beans')" />
        </div>
      </div>

      <div class="list-fields right-read" v-for="(item, index) in weekData.hostIncomes" :key="item.index">
        <div class="bd-field field1 user-info">
          <div class="list-rank">
            <div v-if="index == 0" class="num first">1</div>
            <div v-else-if="index == 1" class="num second">2</div>
            <div v-else-if="index == 2" class="num third">3</div>
            <div v-else class="num normal">{{ index + 1 }}</div>
          </div>
          <div class="name-id">
            <div class="name-wrap">
              <span>{{ item.nickname }}</span>
              <img :src="item.locationFlag | imgPath" />
            </div>
            <div class="id-wrap" @click="handleCopy(item.presentId, $t('lang.msgCopySuccss'))">
              ID:{{ item.presentId }}
              <img src="../images/copy-gray.png" alt="" />
            </div>
          </div>
        </div>
        <div class="bd-field field2">{{ item.hostIncome }}</div>
        <div class="bd-field field3">{{ item.hostIncomeCommission }}</div>
      </div>

      <div class="more-performance right-read" @click="toPerformance">
        <span>{{ $t('lang.newInvite.k048') }}</span>
        <img class="ar-arrow" src="../images/arrow-r.png" alt="" />
      </div>
    </div>

    <div style="height: 450px"></div>

    <!-- step5 -->
    <div class="newguy-guide" id="guide-step5" @click="handleGuideClick(5)">
      <div class="step4">
        <div class="btn-wrap">
          <div class="newguy-guide-btn">
            <div @click="handleGuideClick(5)">{{ $t('lang.ok') }}</div>
          </div>
        </div>

        <div class="card-block">
          <div class="tit-tips" id="invite-guide-dd">
            <div class="block-title right-read">
              {{ $t('lang.newInvite.k012') }}
              <img src="../images/rules-tips2.png" />
            </div>
            <div class="beans-got">
              <img :src="getMatchImg('beans')" />
              500
            </div>
          </div>
        </div>

        <div class="newguy-guide-tips">
          <div class="tips-content">
            <div class="tips-title right-align right-read">{{ $t('lang.newInvite.k047') }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- step4 -->
    <div class="newguy-guide" id="guide-step4" @click="handleGuideClick(4)">
      <div class="step5">
        <div class="btn-wrap">
          <div class="newguy-guide-btn">
            <div @click="handleGuideClick(4)">{{ $t('lang.newInvite.k050') }}</div>
          </div>
        </div>

        <div class="newguy-guide-percent" id="invite-guide-cc">
          <PercentBar
            :percentCount="10000"
            :earnTypeList="[
              {
                minBeans: 0,
                levelRate: 5
              },
              {
                minBeans: 100000,
                levelRate: 8
              },
              {
                minBeans: 100000,
                levelRate: 8
              },
              {
                minBeans: 10000000,
                levelRate: 20
              }
            ]"
          ></PercentBar>
        </div>

        <div class="newguy-guide-tips">
          <div class="tips-content">
            <p class="tips-title right-read right-align">{{ $t('lang.newInvite.k045') }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiFetchWeekIncome } from '@/api/imee'
import { tabEnmu } from '../utils/enum'

import PercentBar from './PercentBar.vue'

export default {
  components: {
    PercentBar
  },
  props: {
    info: {
      type: Object,
      default: () => {
        return undefined
      }
    }
  },
  data() {
    let query = this.$route.query
    return {
      barHeight: query.statusBarHeight || 38,
      tabIndex: 1,
      listQuery: {
        limit: 20,
        offset: 0
      },
      // 列表数据
      weekData: []
    }
  },
  methods: {
    toRules() {
      window.sessionStorage.setItem('inviteV2Tabindex', tabEnmu.commission)
      this.$router.push({ path: '/invite-v2-rules', query: { fromPage: 'invite-v2', location: 'commission' } })
    },
    // 跳转到违规页面
    toViolationDetails() {
      window.sessionStorage.setItem('inviteV2Tabindex', tabEnmu.commission)
      this.$router.push({ path: '/violation-details', query: { fromPage: 'invite-v2' } })
    },
    // 跳转toPerformance
    toPerformance() {
      window.sessionStorage.setItem('inviteV2Tabindex', tabEnmu.commission)
      this.$router.push({ path: '/invite-performance', query: { fromPage: 'invite-v2' } })
    },
    handleGuideClick(arg) {
      this.$emit('stepChange', `step${arg + 1}`)
    },
    // 获得周收益列表  1-本周 2-上周
    fetchWeekIncome(val) {
      let params = {
        timeType: val,
        ...this.listQuery
      }
      apiFetchWeekIncome(params).then((resData) => {
        if (resData) {
          this.weekData = resData

          // mock-调试数据
          // this.weekData.hostIncomes = [
          //   {
          //     avatar: 'public/app/picture/240407/17124801063419b7cdeac-9ea6-4467-b9c8-d94bdc690d4d.jpg',
          //     createTime: 1712480125000,
          //     ifOnline: false,
          //     ifShowTaskProcess: false,
          //     locationFlag: 'public/picture/flag/BR.png',
          //     nickname: '1896hd',
          //     presentId: '6544976',
          //     state: 1,
          //     uid: 2474,
          //     weekIncome: 100,
          //     weekCommission: 1000
          //   }
          // ]
        }
      })
    }
  },
  created() {
    this.fetchWeekIncome(1)
  }
}
</script>
<style lang="scss" scoped>
.commmmission-tab-root {
  .card-block {
    width: 343px;
    min-height: 223px;
    background: #ffffff;
    border-radius: 8px;
    margin: 0 auto 16px;
    position: relative;
    .tit-tips {
      padding-bottom: 18px;
    }
    .block-title {
      font-family: RobotoFlex;
      font-weight: bold;
      font-size: 17px;
      color: #333333;
      text-align: center;
      line-height: 16px;
      padding: 16px 0;
      position: relative;
      img {
        width: 16px;
        height: 16px;
        vertical-align: middle;
        position: absolute;
        top: 50%;
        right: 16px;
        margin-top: -8px;
      }
    }
    .beans-got {
      width: 100%;
      text-align: center;
      font-family: RobotoFlex;
      font-weight: bold;
      font-size: 20px;
      color: #333333;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 4px;

      img {
        width: 20px;
        height: 20px;
        margin: 0 2px;
      }
    }
    .percent-bar {
      width: 319px;
      height: 54px;
      margin: 0 auto;
      padding-top: 12px;
    }
    .vlolation-deduction {
      width: 319px;
      line-height: 18px;
      margin: 16px auto;
      padding: 12px 0;
      border-top: 1px solid #ededed;
      font-family: RobotoFlex;
      font-weight: 400;
      font-size: 15px;
      color: #333333;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .beans-icon {
        width: 14px;
        height: 14px;
        display: inline-block;
        vertical-align: middle;
      }

      span {
        display: inline-block;
        vertical-align: middle;
        margin: 0 4px;
      }

      .arrow-icon {
        width: 12px;
        height: 12px;
        display: inline-block;
        vertical-align: middle;
      }
    }

    // hostess
    .deliver-line {
      width: 319px;
      height: 1px;
      margin: 0 auto;
      transform: rotateX(45deg);
      background: #ededed;
    }

    .list-fields {
      width: 100%;
      display: flex;
      padding: 0 12px;
      margin: 14px 0;
      .field {
        font-family: RobotoFlex;
        font-weight: 400;
        font-size: 14px;
        color: #b2b2b2;
        text-align: center;
        img {
          width: 14px;
          height: 14px;
          vertical-align: middle;
        }
      }
      .field1 {
        width: 142px;
      }
      .field2 {
        width: 85px;
      }
      .field3 {
        width: 105px;
      }

      .bd-field {
        min-height: 36px;
        font-family: RobotoFlex;
        font-weight: 400;
        font-size: 15px;
        color: #333333;
        text-align: center;
        &.field2 {
          line-height: 36px;
        }
        &.field3 {
          line-height: 36px;
        }
      }
      .user-info {
        display: flex;
        .list-rank {
          box-sizing: content-box;
          height: 100%;
          width: 16px;
          display: flex;
          align-items: center;
          padding-right: 8px;
          .num {
            width: 16px;
            height: 16px;
            line-height: 16px;
            border-radius: 50%;
            font-family: RobotoFlex;
            font-weight: 400;
            font-size: 12px;
            color: #ffffff;
          }
          .num.first {
            background-color: #fed141;
          }
          .num.second {
            background-color: #bc6cff;
          }
          .num.third {
            background-color: #aabfff;
          }
          .num.normal {
            color: #333333;
          }
        }
        .name-id {
          text-align: left;
          .name-wrap {
            max-width: 98px;
            font-size: 0;
            text-align: left;
            display: flex;
            align-items: center;
            span {
              max-width: 80px;
              font-family: RobotoFlex;
              font-weight: 400;
              font-size: 15px;
              color: #333333;
              text-align: left;
              overflow: hidden;
              white-space: nowrap;
            }
            img {
              width: 12px;
              height: 12px;
              border-radius: 50%;
              margin-left: 5px;
              margin-top: 2px;
              border: 0.5px solid rgba(102, 102, 102, 0.1);
            }
          }
          .id-wrap {
            display: inline-block;
            margin-top: 4px;
            font-family: RobotoFlex;
            font-weight: 400;
            font-size: 12px;
            color: #b2b2b2;
            text-align: left;
            position: relative;
            word-break: break-all;
            img {
              width: 12px;
              height: 12px;
              margin-left: 4px;
              position: absolute;
              top: 50%;
              right: -17px;
              margin-top: -5px;
            }
          }
        }
      }
    }

    .more-performance {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      line-height: 18px;
      text-align: center;
      padding: 10px 0 24px;
      span {
        font-family: RobotoFlex;
        font-size: 15px;
        color: #a338fc;
      }
      img {
        display: inline-block;
        width: 12px;
        height: 12px;
        margin-top: 2px;
      }
    }
  }

  .pd-gap {
    padding-bottom: 54px;
  }

  .newguy-guide {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: -999;
    opacity: 0;
    background-color: rgba(0, 0, 0, 0.7);

    .newguy-guide-btn {
      min-width: 72px;
      height: 30px;
      padding: 0 10px;
      border-radius: 20px;
      border: 1px solid #ffffff;
      font-family: RobotoFlex;
      font-weight: 400;
      font-size: 15px;
      color: #ffffff;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }

    .newguy-guide-tips {
      padding: 12px 20px;
      width: 100%;
      background: #fdfdfd;
      border-radius: 8px;
      margin-top: 22px;
      .tips-content {
        width: 100%;
        height: 100%;
        position: relative;
        &::after {
          content: '';
          position: absolute;
          left: 30%;
          top: -18px;
          z-index: -1;
          width: 16px;
          height: 16px;
          border-radius: 3px;
          background: #fdfdfd;
          transform: rotate(45deg);
        }

        .tips-title {
          margin: 0 auto;
          font-family: RobotoFlex;
          font-weight: normal;
          font-size: 15px;
          color: #333333;
        }
      }
    }

    .step4 {
      position: absolute;
      top: 280px;
      left: 16px;
      width: 343px;

      .btn-wrap {
        text-align: right;
      }

      .card-block {
        height: 96px;
        min-height: 0;
        user-select: none;
        pointer-events: none;
        margin-top: 20px;
      }

      .newguy-guide-tips {
        width: 280px;
        padding: 12px 20px;
        margin: 20px auto 0;
        .tips-content {
          &::after {
            left: 50%;
            top: -18px;
            z-index: -1;
            margin-left: -8px;
          }

          .tips-title {
            letter-spacing: -0.5px;
          }
        }
      }
    }

    .step5 {
      position: absolute;
      top: 280px;
      left: 16px;
      width: 343px;

      .btn-wrap {
        text-align: right;
        margin-bottom: 20px;
      }

      .newguy-guide-percent {
        padding: 12px;
        background-color: #fdfdfd;
        border-radius: 8px;
        user-select: none;
        pointer-events: none;
      }
    }
  }
}

.commmmission-tab-root.kiko {
  .card-block {
    width: 343px;
    min-height: 223px;
    background: #ffffff;
    border-radius: 8px;
    margin: 0 auto 16px;
    position: relative;
    .tit-tips {
      padding-bottom: 18px;
    }
    .block-title {
      font-family: RobotoFlex;
      font-weight: bold;
      font-size: 17px;
      color: #333333;
      text-align: center;
      line-height: 16px;
      padding: 16px 0;
      position: relative;
      img {
        width: 16px;
        height: 16px;
        vertical-align: middle;
        position: absolute;
        top: 50%;
        right: 16px;
        margin-top: -8px;
      }
    }
    .beans-got {
      width: 100%;
      text-align: center;
      font-family: RobotoFlex;
      font-weight: bold;
      font-size: 20px;
      color: #333333;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 4px;

      img {
        width: 24px;
        height: 24px;
      }
    }
    .percent-bar {
      width: 319px;
      height: 54px;
      margin: 0 auto;
      padding-top: 12px;
    }
    .vlolation-deduction {
      width: 319px;
      line-height: 18px;
      margin: 16px auto;
      padding: 12px 0;
      border-top: 1px solid #ededed;
      font-family: RobotoFlex;
      font-weight: 400;
      font-size: 15px;
      color: #333333;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .beans-icon {
        width: 14px;
        height: 14px;
        display: inline-block;
        vertical-align: middle;
      }

      span {
        display: inline-block;
        vertical-align: middle;
        margin: 0 4px;
      }

      .arrow-icon {
        width: 12px;
        height: 12px;
        display: inline-block;
        vertical-align: middle;
      }
    }

    // hostess
    .deliver-line {
      width: 319px;
      height: 1px;
      margin: 0 auto;
      transform: rotateX(45deg);
      background: #ededed;
    }

    .list-fields {
      width: 100%;
      display: flex;
      padding: 0 12px;
      margin: 14px 0;
      .field {
        font-family: RobotoFlex;
        font-weight: 400;
        font-size: 14px;
        color: #b2b2b2;
        text-align: center;
        img {
          width: 14px;
          height: 14px;
          vertical-align: middle;
        }
      }
      .field1 {
        width: 142px;
      }
      .field2 {
        width: 85px;
      }
      .field3 {
        width: 105px;
      }

      .bd-field {
        min-height: 36px;
        font-family: RobotoFlex;
        font-weight: 400;
        font-size: 15px;
        color: #333333;
        text-align: center;
        &.field2 {
          line-height: 36px;
        }
        &.field3 {
          line-height: 36px;
        }
      }
      .user-info {
        display: flex;
        .list-rank {
          box-sizing: content-box;
          height: 100%;
          width: 16px;
          display: flex;
          align-items: center;
          padding-right: 8px;
          .num {
            width: 16px;
            height: 16px;
            line-height: 16px;
            border-radius: 50%;
            font-family: RobotoFlex;
            font-weight: 400;
            font-size: 12px;
            color: #ffffff;
          }
          .num.first {
            background-color: #fed141;
          }
          .num.second {
            background-color: #bc6cff;
          }
          .num.third {
            background-color: #aabfff;
          }
          .num.normal {
            color: #333333;
          }
        }
        .name-id {
          text-align: left;
          .name-wrap {
            max-width: 98px;
            font-size: 0;
            text-align: left;
            display: flex;
            align-items: center;
            span {
              max-width: 80px;
              font-family: RobotoFlex;
              font-weight: 400;
              font-size: 15px;
              color: #333333;
              text-align: left;
              overflow: hidden;
              white-space: nowrap;
            }
            img {
              width: 12px;
              height: 12px;
              border-radius: 50%;
              margin-left: 5px;
              margin-top: 2px;
              border: 0.5px solid rgba(102, 102, 102, 0.1);
            }
          }
          .id-wrap {
            display: inline-block;
            margin-top: 4px;
            font-family: RobotoFlex;
            font-weight: 400;
            font-size: 12px;
            color: #b2b2b2;
            text-align: left;
            position: relative;
            word-break: break-all;
            img {
              width: 12px;
              height: 12px;
              margin-left: 4px;
              position: absolute;
              top: 50%;
              right: -17px;
              margin-top: -5px;
            }
          }
        }
      }
    }

    .more-performance {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      line-height: 18px;
      text-align: center;
      padding: 10px 0 24px;
      span {
        font-family: RobotoFlex;
        font-size: 15px;
        color: #006cae;
      }
      img {
        display: inline-block;
        width: 12px;
        height: 12px;
        margin-top: 2px;
      }
    }
  }

  .pd-gap {
    padding-bottom: 54px;
  }

  .newguy-guide {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: -999;
    opacity: 0;
    background-color: rgba(0, 0, 0, 0.7);

    .newguy-guide-btn {
      min-width: 72px;
      height: 30px;
      padding: 0 10px;
      border-radius: 20px;
      border: 1px solid #ffffff;
      font-family: RobotoFlex;
      font-weight: 400;
      font-size: 15px;
      color: #ffffff;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }

    .newguy-guide-tips {
      padding: 12px 20px;
      width: 100%;
      background: #fdfdfd;
      border-radius: 8px;
      margin-top: 22px;
      .tips-content {
        width: 100%;
        height: 100%;
        position: relative;
        &::after {
          content: '';
          position: absolute;
          left: 30%;
          top: -18px;
          z-index: -1;
          width: 16px;
          height: 16px;
          border-radius: 3px;
          background: #fdfdfd;
          transform: rotate(45deg);
        }

        .tips-title {
          margin: 0 auto;
          font-family: RobotoFlex;
          font-weight: normal;
          font-size: 15px;
          color: #333333;
        }
      }
    }

    .step4 {
      position: absolute;
      top: 280px;
      left: 16px;
      width: 343px;

      .btn-wrap {
        text-align: right;
      }

      .card-block {
        height: 96px;
        min-height: 0;
        user-select: none;
        pointer-events: none;
        margin-top: 20px;
      }

      .newguy-guide-tips {
        width: 280px;
        padding: 12px 20px;
        margin: 20px auto 0;
        .tips-content {
          &::after {
            left: 50%;
            top: -18px;
            z-index: -1;
            margin-left: -8px;
          }

          .tips-title {
            letter-spacing: -0.5px;
          }
        }
      }
    }

    .step5 {
      position: absolute;
      top: 280px;
      left: 16px;
      width: 343px;

      .btn-wrap {
        text-align: right;
        margin-bottom: 20px;
      }

      .newguy-guide-percent {
        padding: 12px;
        background-color: #fdfdfd;
        border-radius: 8px;
        user-select: none;
        pointer-events: none;
      }
    }
  }
}

.ar-style {
  .block-title {
    img {
      right: auto !important;
      left: 16px !important;
      transform: rotate(0deg) !important;
    }
  }

  .list-rank {
    padding-right: 0 !important;
    padding-left: 8px !important;
  }

  .name-id {
    text-align: right !important;
    .name-wrap {
      text-align: right !important;
      img {
        margin-left: 0 !important;
        margin-right: 5px !important;
      }
    }
    .id-wrap {
      text-align: right !important;
      img {
        left: -17px !important;
        right: auto !important;
        text-align: right !important;
      }
    }
  }
}
</style>
